import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { MegaMenu, Footer, ToastProvider, ToastContainer, initTheme, onThemeChange } from '@watkinslabs/watkinsx-components';
import '@watkinslabs/watkinsx-components/dist/index.css';
import './App.css';
import './pulse.css';
import Hero from './components/Hero.jsx';
import StudioSection from './sections/StudioSection.jsx';
import ScriptSection from './sections/ScriptSection.jsx';
import BinarySection from './sections/BinarySection.jsx';
import ExportSection from './sections/ExportSection.jsx';
import BonesSection from './sections/BonesSection.jsx';
import GovernorSection from './sections/GovernorSection.jsx';
import BenchSection from './sections/BenchSection.jsx';
import StartSection from './sections/StartSection.jsx';

// Facts from pulse-player's README and a measurement of the current build.
const FACTS = [
  ['WebGL2', 'one dependency-free runtime'],
  ['155 KB', 'gzipped, the whole runtime (UMD build)'],
  ['JSON', 'a scene is plain data: any moment is a pure function of it'],
  ['MIT', 'open source'],
];

const NAV = [
  ['#studio', 'Studio'],
  ['#pulsescript', 'PulseScript'],
  ['#binary', '.pulse'],
  ['#export', 'Export'],
  ['#bones', 'Bones'],
  ['#governor', 'Governor'],
  ['#bench', 'Benchmarks'],
  ['#start', 'Get started'],
];

function App() {
  useEffect(() => {
    // CI replaces index.html with the template's, so the page names itself here.
    document.title = 'Pulse · WatkinsX';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement('meta'); meta.name = 'description'; document.head.appendChild(meta); }
    meta.content = 'Pulse: motion graphics from a JSON document, drawn live with WebGL2. A live capability showcase with a performance HUD, Studio, PulseScript, the .pulse format, in-browser export, bones and the performance governor.';
    initTheme();
    const unsubscribe = onThemeChange(() => {});
    return () => unsubscribe();
  }, []);

  return (
    <ToastProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="App pulse-site">
          <MegaMenu title="Pulse" tagline="Motion graphics from a JSON document, drawn with WebGL2" />
          <main className="app-content" id="main">
            <Hero />
            <div className="facts">
              <div className="wrap facts-row">
                {FACTS.map(([big, small]) => (
                  <div className="fact" key={big}><b>{big}</b><span>{small}</span></div>
                ))}
              </div>
            </div>
            <nav className="subnav" aria-label="On this page">
              <div className="wrap subnav-row">
                {NAV.map(([href, label]) => <a key={href} href={href}>{label}</a>)}
              </div>
            </nav>
            <StudioSection />
            <ScriptSection />
            <BinarySection />
            <ExportSection />
            <BonesSection />
            <GovernorSection />
            <BenchSection />
            <StartSection />
          </main>
          <Footer />
          <ToastContainer />
        </div>
      </Router>
    </ToastProvider>
  );
}

export default App;
